import {
  pdfaConversionNotFoundResponseSchema,
  pdfaConversionStatusResponseSchema,
} from 'xosign-types';
import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const statusRequestSchema = z.object({
  conversionId: z.string(),
});

const endpoints = {
  'pdfConversion.status': {
    method: 'GET',
    url: `${API_URL_BASE}pdfa-conversion/:conversionId/status`,
    requestSchema: statusRequestSchema,
    responseSuccessSchema: pdfaConversionStatusResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      404: pdfaConversionNotFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof statusRequestSchema,
    typeof pdfaConversionStatusResponseSchema,
    {
      404: typeof pdfaConversionNotFoundResponseSchema;
    }
  >,
};

export default endpoints;
